module.exports = __webpack_public_path__ + "img/img01.a775149b.png";